<!--供应商审核-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="员工昵称">
            <a-input v-decorator="['nickname']" placeholder="请输入员工昵称"></a-input>
          </a-form-item>
          <a-form-item label="状态">
            <a-select
              class="form-control"
              :options="typesMap.businessTypeList"
              v-decorator="['businessType']"
              placeholder="请选择"
              showSearch
              :filterOption="filterByPY$t"
            ></a-select>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">供应商员工列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" type="primary" @click="addSupplierUser">
          <app-icon type="icon-tianjia"></app-icon>
          创建员工
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="useRowIndex"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :scroll="{ x: 1400 }"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        >
          <!-- 操作列 -->
          <template slot="handler" slot-scope="text, row">
            <div class="flex gap-5 justify-center text-primary-500">
              <a-button type="link" size="small" @click="enableDisable(row)">
                {{ row.status == 0 ? '禁用' : '启用' }}
              </a-button>
              <a-button type="link" size="small" @click="editRow(row)">编辑</a-button>
              <a-button type="link" size="small" @click="removeRow(row)">删除</a-button>
            </div>
          </template>
        </a-table>
      </div>
      <a-modal v-model="modal.visible" :title="modal.title" @cancel="handleCancel" @ok="handleOk">
        <a-form
          :form="modal.form"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
        >
          <a-form-item label="员工昵称">
            <a-input
              v-decorator="[
                'nickname',
                {
                  rules: [
                    { required: true, message: '请输入员工昵称' },
                    { max: 20, message: '最多输入20个字符' },
                  ],
                },
              ]"
              placeholder="请输入员工昵称"
            ></a-input>
          </a-form-item>
          <a-form-item label="账号/手机号">
            <a-input
              v-decorator="[
                'phoneNumber',
                {
                  rules: [
                    { required: true, message: '请输入账号/手机号' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' },
                  ],
                },
              ]"
              placeholder="请输入账号/手机号"
            ></a-input>
          </a-form-item>
          <a-form-item label="密码">
            <a-input
              v-decorator="['password', { rules: [{ required: modal.title == '创建员工', message: '请输入密码' }] }]"
              placeholder="请输入密码"
            ></a-input>
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'

export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '60px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '用户昵称',
        align: 'center',
        dataIndex: 'nickname',
      },
      {
        title: '用户状态',
        align: 'center',
        dataIndex: 'status',
        customRender: (text, row) => {
          return <span>{ text == 0 ? '启用中' : '已禁用'}</span>
        },
      },
      {
        title: '操作',
        width: '200px',
        align: 'center',
        dataIndex: 'detail',
        scopedSlots: {
          customRender: 'handler',
        },
      },
    ]
    return {
      formItemLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          offset: 5
        },
      },
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      supplierId: '',
      modal: {
        visible: false,
        title: '添加员工',
        form: this.$form.createForm(this),
        data: {},
      },
      dataSource: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        businessTypeList: [
          { value: 0, label: '启用' },
          { value: 10, label: '禁用' },
        ],
      }
    },
  },
  methods: {
    handleCancel() {
      this.modal.visible = false
    },
    handleOk() {
      this.modal.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            ...values,
            supplierId: this.supplierId,
          }
          if (this.modal.title == '编辑员工') {
            params.userId = this.modal.data.userId
          }
          this.$axios.post(`/user/admin/supplier/user`, params).then(res => {
            if (res.success) {
              this.$message.success('操作成功!')
              this.handleCancel()
              this.doQuery()
            }
          })
        }
      })
    },
    removeRow(row) {
      this.$confirm({
        title: '提示',
        content: '确定删除?',
        onOk: () => {
          this.$axios
            .delete(`/user/admin/supplier/user?supplierId=${row.supplierId}&userId=${row.userId}`)
            .then(res => {
              if (res.success) {
                this.$message.success('操作成功!')
                this.doQuery()
              }
            })
        },
        onCancel: () => {},
      })
    },
    enableDisable(row) {
      this.$axios
        .put(
          `/user/admin/supplier/user/status?supplierId=${row.supplierId}&userId=${row.userId}&status=${
            row.status == 0 ? 10 : 0
          }`
        )
        .then(res => {
          if (res.success) {
            this.$message.success('操作成功')
            this.doQuery()
          }
        })
    },
    addSupplierUser() {
      this.modal.title = '创建员工'
      this.modal.visible = true
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.get('/user/admin/supplier/user', {
          params: {
            supplierId: this.$route.query.supplierId,
            ...this.form.getFieldsValue(),
            page: _pageNumber,
            limit: _pageSize,
          },
        })
        this.countTotal = Number(res.count)
        this.pageSize = _pageSize
        this.pageNumber = _pageNumber
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    transformAdvantage(text) {
      let result = ''
      try {
        const list = JSON.parse(text)

        list.map((item, index) => {
          const separetor = index === 0 ? '' : ','
          result += separetor + item.label
        })
      } catch (e) {}
      return result
    },
    checkRow(row) {
      this.$router.push({
        path: `/m/scopeMain/merchantAudit/merchantAuditDetail`,
        query: {
          supplierId: row.supplierId,
          type: 'DETAIL',
        },
      })
    },
    editRow(row) {
      this.modal.title = '编辑员工'
      this.modal.visible = true
      this.safeSetFieldsValue$t(this.modal.form, { ...row })
      this.modal.data = { ...row }
    },
  },
  mounted() {
    this.$route.query.supplierId && (this.supplierId = this.$route.query.supplierId)
    this.doQuery()
  },
}
</script>

<style lang="less" scoped>
.audit-status-img {
  width: 105px;
  height: 105px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
</style>
